import { render } from "./UnderDevelopment.vue?vue&type=template&id=6ebb3f23&scoped=true"
import script from "./UnderDevelopment.vue?vue&type=script&lang=js"
export * from "./UnderDevelopment.vue?vue&type=script&lang=js"

import "./UnderDevelopment.vue?vue&type=style&index=0&id=6ebb3f23&scoped=true&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebb3f23"]])

export default __exports__